import { Container } from "react-bootstrap";
import { Bullseye, Lightbulb, LightningCharge, People, Linkedin, BoxArrowUpRight } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import "./Careers.css";
import { Reveal } from "../../animate/Reveal";

const coreValues = [
  {
    icon: <LightningCharge />,
    title: "Determination",
    text: "We push boundaries and stay resilient, chasing big goals with a relentless drive to deliver.",
  },
  {
    icon: <Lightbulb />,
    title: "Innovation",
    text: "We experiment, learn fast and use cutting-edge technology to create products people love.",
  },
  {
    icon: <Bullseye />,
    title: "Focus",
    text: "We stay aligned on what matters most — shipping value for our users and our team.",
  },
];

function Careers() {
  return (
    <div>
      <section className="careersHero">
        <div className="careersHeroInner">
          <div className="careersBadge">Careers</div>
          <Reveal>
            <h1>Work with us</h1>
          </Reveal>
          <Reveal>
            <p>
              Join a team building the future of social messaging — where great
              ideas meet a culture that values people, growth and impact.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="careersValues">
        <Container>
          <div className="careersValuesGrid">
            {coreValues.map((v) => (
              <div key={v.title} className="careersValueCard">
                <div className="careersValueIcon">{v.icon}</div>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="careersDetail">
        <Container>
          <div className="careersJoinLayout">
            <Reveal>
              <div className="careersImage">
                <img src="team.jpeg" alt="join_our_team" />
              </div>
            </Reveal>
            <Reveal>
              <div className="careersText">
                <h2>Join Us Today</h2>
                <p>
                  At SoloChat, we strive to create a diverse and inclusive
                  culture that fosters innovation that improves people's lives.
                  We're dedicated to recruiting talented professionals who share
                  in our core values of determination, innovation, and focus,
                  and are passionate about making a difference in the social
                  networking industry. If you're looking for an exciting career
                  opportunity in tech, follow us on{" "}
                  <a
                    href="https://www.linkedin.com/company/SoloChat/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>{" "}
                  for updates on current openings at SoloChat. We welcome
                  individuals with fresh ideas and a strong drive to innovate.
                </p>
                <a
                  className="careersLinkedInBtn"
                  href="https://www.linkedin.com/company/SoloChat/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin />
                  Follow us on LinkedIn
                  <BoxArrowUpRight className="careersLinkedInIcon" />
                </a>
              </div>
            </Reveal>
          </div>
        </Container>
      </section>

      <section className="careersOpenRoles">
        <Container>
          <div className="careersOpenRolesInner">
            <div className="careersOpenRolesIcon">
              <People />
            </div>
            <h2>Don't see a role that fits?</h2>
            <p>
              We're always excited to meet talented people. Reach out and tell
              us how you'd love to contribute.
            </p>
            <Link className="careersOpenRolesBtn" to="/contact">
              Get in touch
            </Link>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default Careers;
